module.exports = __webpack_public_path__ + "img/Silver IV.1ae1861b.png";